<template>
  <div class="btn-group full-width force-center">

    <input
        required
        name="locality"
        type="search"
        class="form-control"
        :placeholder="this.__('search.search-placeholder')"
        aria-label="Search"
        v-model="inputValLoc"/>

    <slot name="image-search"></slot>

    <button
        class="btn"
        type="button"
        id="header-search-icon"
        aria-label="Search"
        @click="submitForm"
    >
      <i class="fs16 fw6 rango-search"></i>
    </button>
  </div>
</template>

<script type="text/javascript">
export default {
  data: function () {
    return {
      inputValLoc: '',
      searchedQuery: []
    };
  },

  created: function () {
    let searchedItem = window.location.search.replace('?', '');
    searchedItem = searchedItem.split('&');

    let updatedSearchedCollection = {};

    searchedItem.forEach(item => {
      let splitedItem = item.split('=');
      updatedSearchedCollection[splitedItem[0]] = decodeURI(
          splitedItem[1]
      );
    });

    if (updatedSearchedCollection['image-search'] == 1) {
      updatedSearchedCollection.term = '';
    }

    this.searchedQuery = updatedSearchedCollection;

    if (this.searchedQuery.locality) {
      this.inputValLoc = decodeURIComponent(
          this.searchedQuery.locality.split('+').join(' ')
      );
    }
  },

  methods: {
    focusInput: function (event) {
      $(event.target.parentElement.parentElement)
          .find('input')
          .focus();
    },

    submitForm: function () {
      if (this.inputValLoc !== '') {
        $('input[name=locality]').val(this.inputValLoc);
        $('#search-form').submit();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/Resources/assets/js/UI/components/header-searchbar.vue